<!--  -->
<template>
    <div>
        <el-container>
            <!-- 左侧容器 -->
            <el-aside class="left" :width="asideWidth">
                <el-scrollbar>
                    <!-- logo -->
                    <div class="logo">
                        <img src="../assets/image/3.png" />
                        <span v-show="!isCollapse" style="font-family: 'Courier New', Courier, monospace;">远程居家髋部锻炼指导</span>
                    </div>
                    <!-- 动态菜单 -->
                    <el-menu @select="menuSelect" :router="true" :collapse="isCollapse" :collapse-transition="false" style="border-right:none;" background-color="#5b6f88" text-color="#bfcbd9">
                        <MenuList :mlist="permissionState.sidebarRoute"/>
                    </el-menu>

                </el-scrollbar>
            </el-aside>

            <!-- 右侧容器 -->
            <el-container>
                <el-header class="head" height="45px">
                    <el-row>
                        <el-col :span="12" class="head-l">
                            <el-icon @click="isCollapse = !isCollapse" class="hand">
                                <Fold v-if="!isCollapse" />
                                <Expand v-else />
                            </el-icon>
                        </el-col>
                        <el-col :span="12" class="head-r">
                            <el-dropdown @command="dropdownHandler">
                                <span style="cursor: pointer;">
                                    <el-icon style="top:2px;">
                                        <Avatar />
                                    </el-icon>
                                    设置
                                    <el-icon style="top:2px;" class="el-icon--right">
                                        <ArrowDownBold />
                                    </el-icon>
                                </span>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item divided command="exit">退出登录</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </el-col>
                    </el-row>
                </el-header>
                <el-main style="height:0;flex-grow:1;">
                    <el-tabs 
                        type="card" 
                        @tab-click="tabClick"
                        @tab-remove="tabRemove"
                        v-model="tabsState.activeIndex">
                        <!--首页不动-->
                        <el-tab-pane label="首页" name="/appmain/home">
                            <router-view v-slot="{ Component,route }">
                                <keep-alive v-if="route.meta.keepalive">
                                    <component :is="Component" />
                                </keep-alive>
                                <component :is="Component" v-else />
                            </router-view>  
                        </el-tab-pane>
                        <el-tab-pane 
                            :closable="true"
                            :label="item.title"
                            :name="item.path"
                            v-for="(item,index) in tabsState.openTab" :key="index">
                            <!-- <router-view v-slot="{ Component,route }">
                                <keep-alive v-if="route.meta.keepalive">
                                    <component :is="Component" />
                                </keep-alive>
                                <component :is="Component" v-else />
                            </router-view> -->
                            <router-view v-slot="{ Component }">
                                <keep-alive>
                                    <component :is="Component"></component>
                                </keep-alive>
                            </router-view>
                        </el-tab-pane>
                    </el-tabs>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script setup>
import { ref, reactive, computed } from "vue"
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Home from '@/views/home'
import MenuList from '@/components/MenuList'

const aaa = reactive({
    name:'张三'
})

const store = useStore()
const router = useRouter()
const route = useRoute()

// user全局状态
const userState = computed(() => store.state.user)
// permission全局状态
const permissionState=computed(()=>store.state.permission)


// tabs选项卡vuex状态对象
const tabsState=computed(()=>store.state.tabs)

// 是否收起侧边栏
const isCollapse = ref(false)

// 折叠菜单aside宽度变化监控
const asideWidth = computed(() => isCollapse.value ? '65px' : '230px')

/** 退出登录 */
const loginOut = () => {
    ElMessageBox.confirm('确定退出登录吗？', '提醒', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
    }).then(()=>{
        // 清除动许可相关内容
        store.commit('permission/LOGIN_OUT')
        // 清除动态选项卡相关内容
        store.commit('tabs/LOGIN_OUT')

        // 退出
        router.push({path:'/login'})
    }).catch(()=>{
        
    })
}

/** 顶部功能栏事件函数 */
const dropdownHandler = (command) => {
    loginOut()
}

/** 叶子菜单 */
const menuSelect=(pIndex,indexPath,item,pRouter)=>{
    // 判断当前菜单对应的选项卡是否已经打开，打开则激活，否则新增
    let index=store.getters['tabs/FIND_TAB'](item.route.path)    

    if(index === -1){
        // 将点击的菜单参数作为选项卡所需数据加入到vuex的tabs中
        store.commit('tabs/ADD_TAB',item.route)
    }

    // 激活该选项卡
    store.commit('tabs/ACTIVE_TAB',item.route.path)

    // 重新跳转到该选项卡对应的路由
    router.push({path:item.route.path})
    
}

/** 选项卡被点击时触发 */
const tabClick=(params)=>{
    // 调用vuex的方法，进行激活选项卡动作
    store.commit('tabs/ACTIVE_TAB',params.props.name)

    // 激活所点击选项卡对应的路由
    router.push({path:params.props.name})
}

/** 选项卡点击删除时触发 */
const tabRemove=(tabPanelName)=>{
    // 将选项卡数据删除
    store.commit('tabs/REMOVE_TAB',tabPanelName)

    // 判断删除的是否是处于激活状态的选项卡
    if(tabPanelName===store.state.tabs.activeIndex){
        
        // 判断vuex选项卡数组中是否还有值
        let len=store.state.tabs.openTab.length        

        // 如果数组中没有元素了，那么激活首页
        if(len===0){
            store.commit('tabs/ACTIVE_TAB','/appmain/home')
            // 路由跳转
            router.push({path:'/appmain/home'})
        }else{
            // 激活数组最后一个
            store.commit('tabs/ACTIVE_TAB',store.state.tabs.openTab[len-1].path)
            // 路由跳转
            router.push({path:store.state.tabs.openTab[len-1].path})
        }
    }

}

</script>

<style scoped lang="scss">
/* 解决收缩侧边栏卡顿，注意el-menu需要添加 :collapse-transition="false"去除动画效果*/
.el-aside {
    transition: width 0.15s;
    -webkit-transition: width 0.15s;
    -moz-transition: width 0.15s;
    -webkit-transition: width 0.15s;
    -o-transition: width 0.15s;
}

/*选项卡高度设定*/
.el-tabs {
    --el-tabs-header-height: 33px;
}

.logo {
    height: 50px;
    line-height: 50px;
    padding-left: 13px;
    background-color: #5b6f88;

    img {
        width: 30px;
        vertical-align: middle;
    }

    span {
        color: #fff;
        font-weight: bold;
        padding-left: 8px;
        font-size: 16px;
    }
}

.el-main {
    padding-top: 3px;
    padding-left: 10px;
}

.hand {
    cursor: pointer;
}

.head {
    background-color: #438FAA;
    padding-top: 10px;
    color: #fff;
}

.head .head-l {
    font-size: 18px;
    font-weight: bold;
}

.head .head-r {
    font-size: 18px;
    text-align: right;
}

.left {
    background-color: #5b6f88;
    height: 100vh;
}

.unReadInfo {
    display: inline-block;
    margin-right: 30px;
}

.el-dropdown {
    margin-top: 8px;
}</style>